import type { RecommendedProduct } from '../../../types/messageTypes'
import styles from './FashionAssistantLook.module.scss'
import { FashionAssistantProduct } from './FashionAssistantProduct/FashionAssistantProduct'

export function FashionAssistantLook({
	recommendedLook,
	outfitNumber,
}: {
	readonly recommendedLook: RecommendedProduct[]
	readonly outfitNumber?: number
}) {
	return (
		<div className={styles.fashionAssistantLook}>
			{recommendedLook.map((recommendationProduct) => (
				<FashionAssistantProduct
					product={recommendationProduct}
					key={`${recommendationProduct.id}${recommendationProduct.colorId}${outfitNumber ?? ''}`}
				/>
			))}
		</div>
	)
}
